module.exports = __webpack_public_path__ + "media/testimonials/customer-8-fd0485f3.png";